import ClearingAPI from '@shared/api';

export const {
    positions: { getAffectedPositions },
} = ClearingAPI.settings;
